import { type ReactNode, useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { EErrorTypes } from "app/components/React/empty-state/GenericEmptyState";

import { MetricsWidgetContainer } from "../MetricsWidgetContainer";

import { useMetricWidgetContext } from "./MetricWidgetContext";

interface IMetricWidgetContainerProps {
    title: string;
    automationId: string;
    seeAllAutomationId: string;
    children: ReactNode;
}

export const MetricWidgetContainer = ({
    title,
    automationId,
    seeAllAutomationId,
    children,
}: IMetricWidgetContainerProps) => {
    const { translate } = useTranslate();
    const {
        state: { isLoading, isError, compactChartData, hasOthers },
        actions: { openModal },
    } = useMetricWidgetContext();
    const seeAllButtonConfig = useMemo(
        () =>
            hasOthers
                ? [
                      {
                          type: "flat" as const,
                          onClick: openModal,
                          label: translate("activation.alerts.metrics.see-all"),
                          "data-automation": seeAllAutomationId,
                      },
                  ]
                : undefined,
        [hasOthers, openModal, translate, seeAllAutomationId],
    );

    return (
        <MetricsWidgetContainer
            title={title}
            isLoading={isLoading}
            noData={!isLoading ? isError || !compactChartData : undefined}
            noDataType={isError ? EErrorTypes.ERROR : EErrorTypes.NO_DATA}
            automationId={automationId}
            dynamicButtonsConfig={seeAllButtonConfig}
            withBorder
        >
            {children}
        </MetricsWidgetContainer>
    );
};
